import en from './en'
import de from './de';

export const resources = {
  en,
  de
};